import { useAppSelector } from 'store/store';
import { ROLE_TENANT_OPERATOR } from 'shared/permissions/roles';

export function useIsOperator(): boolean {
  const groups = useAppSelector((state) => state.auth.groups);
  return groups?.includes(ROLE_TENANT_OPERATOR) ?? false;
}
